import { BANNER_ASSOCIATION_ID_TYPES } from "src/constants/AppConstants"

export const ALL = "all"

export const bannerTabIds = {
    "CreateBanner": "create-banner",
    "CurrentBanners": "current-banners"
}

export const DisplayOptions = {
    EVERYWHERE: "everywhere",
    CLOSE_PORTAL: "close-portal",
    APP: "app-pages",
    MICROSERVICE: "microservices",
    SINGLE_MICROSERVICE: "microservice",
    URL_PREFIX: "url-prefix"
}

export const displayOptions = [
    {label: "Everywhere", value: DisplayOptions.EVERYWHERE},
    {label: "Close Portal Pages", value: DisplayOptions.CLOSE_PORTAL},
    {label: "At Given Url Prefixes", value: DisplayOptions.URL_PREFIX},
    {label: "App Pages", value: DisplayOptions.APP},
    {label: "Microservice Pages (i.e FRISCO, FLEXICO, LOGICO)", value: DisplayOptions.MICROSERVICE},
    {label: "A Single Microservice Page", value: DisplayOptions.SINGLE_MICROSERVICE},
]

export const microserviceOptions = [
    {label: "Frisco", value: "frisco", service: BANNER_ASSOCIATION_ID_TYPES.FRISCO},
    {label: "FlexiCo", value: "flexico", service: BANNER_ASSOCIATION_ID_TYPES.FLEXICO},
    {label: "LOGICO", value: "logico", service: BANNER_ASSOCIATION_ID_TYPES.LOGICO},
]

export const bannerTypes = [
    // value is of type FlashbarProps.Type
    { label: "Critical" , value: "error"},
    { label: "Warning" , value: "warning"},
    { label: "Info" , value: "info"},
    { label: "Success" , value: "success"},
];